import { motion } from "framer-motion";
import { ArrowDownRight, MessageCircle } from "lucide-react";
import { MaskLine, scrollToId, EASE } from "./Reveal";
import { HeroPortrait } from "./HeroPortrait";
import { WHATSAPP_URL } from "./data";

const STATS = [
  { k: "0", v: "bisturi e punti di sutura" },
  { k: "1", v: "seduta principale, circa 3 ore" },
  { k: "2", v: "mesi per la rivalutazione" },
];

const fade = (d) => ({ initial: { opacity: 0, y: 18 }, animate: { opacity: 1, y: 0 }, transition: { duration: 1, delay: d, ease: EASE } });

export const Hero = () => (
  <section className="relative min-h-screen bg-[#F4F3EC] pt-32 pb-20 overflow-hidden" data-testid="hero-section">
    <div className="absolute top-0 right-0 w-[60vw] h-[60vw] rounded-full bg-[#E6ECE4] blur-3xl opacity-70 translate-x-1/3 -translate-y-1/3" />
    <div className="relative mx-auto max-w-[1400px] px-6 sm:px-10 grid lg:grid-cols-12 gap-14 lg:gap-10 items-center">
      <div className="lg:col-span-7">
        <motion.p {...fade(0.15)} className="eyebrow text-[#3E6B48] flex items-center gap-3">
          <span className="w-10 h-px bg-[#3E6B48]" /> Parodontite · Laser 450 · 635 · 808 nm
        </motion.p>
        <h1 className="f-serif mt-8 text-[3.4rem] leading-[0.92] sm:text-7xl lg:text-[6.4rem] tracking-[-0.025em] text-[#1B3B28]" data-testid="hero-title">
          <MaskLine delay={0.25}>Curare la</MaskLine>
          <MaskLine delay={0.37}>parodontite</MaskLine>
          <MaskLine delay={0.49}>con la luce,</MaskLine>
          <MaskLine delay={0.61} className="italic text-[#3E6B48]">senza paura.</MaskLine>
        </h1>
        <motion.p {...fade(1.1)} className="mt-10 max-w-xl text-base sm:text-lg text-[#526356] leading-relaxed">
          Un percorso non chirurgico con laser ad alta potenza e microscopio operatorio, pensato per chi ha
          gengive che sanguinano, denti che si muovono — e magari anche un po' di timore del dentista.
        </motion.p>
        <motion.div {...fade(1.25)} className="mt-10 flex flex-wrap items-center gap-4">
          <button
            onClick={() => scrollToId("prenota")}
            data-testid="hero-cta-booking"
            className="group inline-flex items-center gap-3 rounded-full bg-[#1B3B28] text-[#FCFBF7] pl-7 pr-2 py-2 hover:bg-[#3E6B48] transition-colors duration-500"
          >
            Prenota la prima visita
            <span className="grid place-items-center w-10 h-10 rounded-full bg-[#86C89B] text-[#0F2317] transition-transform duration-500 group-hover:-rotate-45">
              <ArrowDownRight size={18} />
            </span>
          </button>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-whatsapp"
            className="inline-flex items-center gap-2 rounded-full border border-[#1B3B28]/20 px-6 py-4 text-[#1B3B28] hover:bg-[#1B3B28]/5 transition-colors"
          >
            <MessageCircle size={17} /> Scrivimi su WhatsApp
          </a>
        </motion.div>
        <motion.dl {...fade(1.45)} className="mt-16 grid grid-cols-3 max-w-xl border-t border-[#1B3B28]/15">
          {STATS.map((s) => (
            <div key={s.k + s.v} className="pt-5 pr-4" data-testid={`hero-stat-${s.k}`}>
              <dt className="f-serif text-5xl text-[#1B3B28]">{s.k}</dt>
              <dd className="text-xs text-[#526356] mt-1 leading-snug">{s.v}</dd>
            </div>
          ))}
        </motion.dl>
      </div>
      <div className="lg:col-span-5 lg:pl-6">
        <div className="max-w-md mx-auto lg:max-w-none">
          <HeroPortrait />
        </div>
      </div>
    </div>
  </section>
);
